<template>
  <wui-input
    v-model.trim="textMessage"
    :placeholder="$t('common.leaveMessage')"
    @focus="emit('focus', $event)"
    @input="emit('update:modelValue', textMessage)"
  />
</template>

<script setup lang="ts">
import { WuiInput } from '@wui/common-library'
import { ref } from 'vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
})

const textMessage = ref(props.modelValue)

const emit = defineEmits<{
  (event: 'update:modelValue', value: string): void;
  (event: 'focus', value: Event): void;
}>()
</script>
